export default __webpack_public_path__ + "media/images/images_v2/logo-3cb9c94fd3e7ff7805682cef1bfae0dd.png";